
export const defaultAvailabilityHours = {
  "48hours": 48,
  weekly: 168
}

export const normalizeCategory = (category) =>
  String(category || "normal").trim().toLowerCase()

export const isLimitedCategory = (category) =>
  ["48hours", "weekly"].includes(normalizeCategory(category))

export const parseFoodImages = (item = {}) => {
  const parsedImages = []

  if (Array.isArray(item.images)) {
    parsedImages.push(...item.images)
  } else if (typeof item.images === "string" && item.images.trim()) {
    try {
      const nextImages = JSON.parse(item.images)

      if (Array.isArray(nextImages)) {
        parsedImages.push(...nextImages)
      }
    } catch {
      parsedImages.push(
        ...item.images
          .split(",")
          .map((part) => part.trim())
      )
    }
  }

  if (item.image) {
    parsedImages.unshift(item.image)
  }

  return Array.from(
    new Set(
      parsedImages
        .map((image) => String(image || "").trim())
        .filter(Boolean)
    )
  ).slice(0, 3)
}

const resolveFoodImageUrl = (
  image,
  apiBase = "",
  fallback = "/logo192.png"
) => {
  if (!image) return fallback

  const imagePath = String(image).trim()
  const backendBase = String(apiBase || "").replace(/\/+$/, "")

  if (/^https?:\/\//i.test(imagePath)) {
    return imagePath
  }

  if (/^\/uploads\//i.test(imagePath)) {
    return `${backendBase}${imagePath}`
  }

  if (/^uploads\//i.test(imagePath)) {
    return `${backendBase}/${imagePath}`
  }

  if (imagePath.startsWith("/")) {
    return imagePath
  }

  return `${backendBase}/uploads/${imagePath}`
}

export const getFoodImageUrl = (
  item = {},
  apiBase = "",
  fallback = "/logo192.png"
) => {
  const image = parseFoodImages(item)[0]

  return resolveFoodImageUrl(image, apiBase, fallback)
}

export const getFoodImageUrls = (
  item = {},
  apiBase = "",
  fallback = "/logo192.png"
) => {
  const images = parseFoodImages(item)

  if (images.length === 0) {
    return [fallback]
  }

  return images.map((image) =>
    resolveFoodImageUrl(image, apiBase, fallback)
  )
}

export const hyderabadPincodeAreas = {
  "500001": "Abids / Nampally",
  "500002": "Charminar",
  "500003": "Secunderabad",
  "500004": "Khairatabad",
  "500005": "Keshavgiri",
  "500006": "Asif Nagar",
  "500007": "Tarnaka / Osmania University",
  "500008": "Golconda",
  "500009": "Bowenpally",
  "500010": "Alwal",
  "500011": "Bowenpally",
  "500012": "Begum Bazar",
  "500013": "Amberpet",
  "500015": "Trimulgherry",
  "500016": "Begumpet / Ameerpet",
  "500017": "Tarnaka",
  "500018": "Sanath Nagar",
  "500020": "Musheerabad",
  "500022": "Central Secretariat",
  "500023": "Yakutpura",
  "500024": "Saidabad",
  "500025": "Chilkalguda",
  "500026": "Marredpally",
  "500027": "Kachiguda",
  "500028": "Humayun Nagar",
  "500029": "Himayatnagar",
  "500030": "Rajendranagar",
  "500031": "Gachibowli",
  "500032": "Gachibowli / Financial District",
  "500033": "Jubilee Hills",
  "500034": "Banjara Hills",
  "500035": "Saroornagar",
  "500036": "Malakpet",
  "500037": "Balanagar",
  "500038": "S R Nagar",
  "500039": "Uppal",
  "500040": "Moula Ali",
  "500041": "Raj Bhavan Road",
  "500042": "Balanagar",
  "500043": "Kompally",
  "500044": "Vidyanagar",
  "500045": "Yousufguda",
  "500047": "Malkajgiri",
  "500048": "Attapur",
  "500049": "Miyapur / Hafeezpet",
  "500050": "Chandanagar",
  "500051": "Hayathnagar",
  "500052": "Falaknuma",
  "500053": "Chandrayanagutta",
  "500054": "Kukatpally",
  "500055": "Jeedimetla",
  "500056": "Sainikpuri",
  "500057": "Santoshnagar",
  "500058": "Kanchanbagh",
  "500059": "Saidabad",
  "500060": "Dilsukhnagar",
  "500061": "Sitaphalmandi",
  "500062": "ECIL",
  "500063": "Domalguda",
  "500064": "Bahadurpura",
  "500065": "Gowliguda",
  "500066": "Shah Ali Banda",
  "500067": "Suchitra",
  "500068": "L B Nagar",
  "500069": "Vanasthalipuram",
  "500070": "Vanasthalipuram",
  "500071": "Hyderabad",
  "500072": "Kukatpally",
  "500073": "Srinagar Colony",
  "500074": "L B Nagar",
  "500076": "Nacharam",
  "500077": "Kattedan",
  "500078": "Kompally",
  "500079": "Saroornagar",
  "500080": "Chikkadpally",
  "500081": "HITEC City",
  "500082": "Somajiguda",
  "500083": "Nagole",
  "500084": "Kondapur",
  "500085": "Kukatpally",
  "500086": "Hyderabad",
  "500087": "Neredmet",
  "500088": "Medipally",
  "500089": "Manikonda",
  "500090": "Nizampet",
  "500091": "Rajendranagar",
  "500092": "Boduppal",
  "500093": "Sainikpuri",
  "500094": "Sainikpuri",
  "500095": "Nampally",
  "500096": "Film Nagar",
  "500097": "Meerpet",
  "500098": "Narapally / Medipally",
  "500100": "Kompally",
  "500101": "Shamirpet",
  "501301": "Ghatkesar"
}

export const normalizePincode = (value) =>
  String(value || "").replace(/\D/g, "").slice(0, 6)

export const getHyderabadPincodeArea = (value) => {
  const pincode = normalizePincode(value)

  if (pincode.length !== 6) return ""

  return hyderabadPincodeAreas[pincode] || ""
}

export const isHyderabadPincode = (value) =>
  Boolean(getHyderabadPincodeArea(value))

export const limitedDeliveryPincodeKey =
  "srilekha_limited_delivery_pincode"

let inMemoryLimitedDeliveryPincode = ""

const getCookieValue = (name) => {
  if (typeof document === "undefined") return ""

  return document.cookie
    .split(";")
    .map((part) => part.trim())
    .find((part) => part.startsWith(`${name}=`))
    ?.split("=")[1] || ""
}

export const getStoredLimitedDeliveryPincode = () => {
  if (typeof window === "undefined") return ""

  let storedPincode = ""

  try {
    storedPincode =
      window.localStorage.getItem(limitedDeliveryPincodeKey) || ""
  } catch {
    storedPincode = ""
  }

  return normalizePincode(
    inMemoryLimitedDeliveryPincode ||
    storedPincode ||
    getCookieValue(limitedDeliveryPincodeKey)
  )
}

export const saveStoredLimitedDeliveryPincode = (value) => {
  const pincode = normalizePincode(value)

  if (isHyderabadPincode(pincode)) {
    inMemoryLimitedDeliveryPincode = pincode

    if (typeof window !== "undefined") {
      try {
        window.localStorage.setItem(
          limitedDeliveryPincodeKey,
          pincode
        )
      } catch {
        // Cookie fallback below keeps checkout in sync.
      }
    }

    if (typeof document !== "undefined") {
      document.cookie =
        `${limitedDeliveryPincodeKey}=${pincode}; ` +
        "path=/; max-age=2592000; SameSite=Lax"
    }
  }

  return pincode
}

export const getPincodeLocation = async (value) => {
  const pincode = normalizePincode(value)

  if (pincode.length !== 6) return null

  const hyderabadArea = getHyderabadPincodeArea(pincode)

  if (hyderabadArea) {
    return {
      area: hyderabadArea,
      city: "Hyderabad",
      country: "India",
      isHyderabad: true,
      pincode,
      state: "Telangana"
    }
  }

  try {
    const res = await fetch(
      `https://api.postalpincode.in/pincode/${pincode}`
    )
    const data = await res.json()
    const postOffice = data?.[0]?.PostOffice?.[0]

    if (!postOffice) return null

    return {
      area: postOffice.Name || "",
      city:
        postOffice.District ||
        postOffice.Block ||
        "",
      country: postOffice.Country || "India",
      isHyderabad: false,
      pincode,
      state: postOffice.State || ""
    }
  } catch {
    return null
  }
}

export const getStockQuantity = (item) => {
  const stockValue =
    item?.stock_quantity ??
    item?.stockQuantity ??
    item?.stock ??
    item?.available_stock ??
    item?.availableStock

  if (
    stockValue === undefined ||
    stockValue === null ||
    stockValue === ""
  ) {
    return null
  }

  const parsed = Number(stockValue)

  return Number.isFinite(parsed) ? parsed : null
}

export const formatStockQuantity = (
  item,
  unit = "items",
  fallback = "Limited stock"
) => {
  const stockQuantity = getStockQuantity(item)

  if (stockQuantity === null) return fallback

  return `${stockQuantity} ${unit}`
}

export const parseFoodDate = (value) => {
  if (!value) return null

  const date = new Date(String(value).replace(" ", "T"))

  if (Number.isNaN(date.getTime())) return null

  return date
}

export const getExpiryDate = (item) => {
  const explicitExpiry = parseFoodDate(item?.expires_at)

  if (explicitExpiry) return explicitExpiry

  const category = normalizeCategory(item?.category)
  const hours =
    Number(item?.availability_hours) ||
    defaultAvailabilityHours[category]

  if (!hours) return null

  const startDate =
    parseFoodDate(item?.created_at) ||
    parseFoodDate(item?.updated_at)

  if (!startDate) return null

  return new Date(
    startDate.getTime() + hours * 60 * 60 * 1000
  )
}

export const getRemainingMs = (item) => {
  const expiresAt = getExpiryDate(item)

  if (!expiresAt) return null

  return expiresAt.getTime() - Date.now()
}

export const isExpired = (item) => {
  const remaining = getRemainingMs(item)

  return remaining !== null && remaining <= 0
}

export const isHidden = (item) =>
  Number(item?.is_visible) === 0

export const isOutOfStock = (item) =>
  Number(item?.is_out_of_stock) === 1 ||
  (
    getStockQuantity(item) !== null &&
    getStockQuantity(item) <= 0
  )

export const isOrderable = (item) =>
  !isHidden(item) &&
  !isExpired(item) &&
  !isOutOfStock(item)

export const filterVisibleFoods = (items = []) =>
  items.filter((item) => !isHidden(item) && !isExpired(item))

export const getFoodStatusLabel = (item) => {
  if (isHidden(item)) return "Hidden"
  if (isExpired(item)) return "Expired"
  if (isOutOfStock(item)) return "Out of Stock"

  return "Available"
}

export const formatRemainingTime = (item) => {
  const remaining = getRemainingMs(item)

  if (remaining === null) return ""
  if (remaining <= 0) return "Ended"

  const totalMinutes = Math.ceil(remaining / 60000)
  const days = Math.floor(totalMinutes / (60 * 24))
  const hours = Math.floor(
    (totalMinutes - days * 60 * 24) / 60
  )
  const minutes = totalMinutes % 60

  if (days > 0) {
    return `${days}d ${hours}h left`
  }

  if (hours > 0) {
    return `${hours}h ${minutes}m left`
  }

  return `${minutes}m left`
}

export const toDateTimeLocal = (value) => {
  const date = parseFoodDate(value)

  if (!date) return ""

  const pad = (part) => String(part).padStart(2, "0")

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`
}
